import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/estimation/new/')({
  beforeLoad: () => {
    throw redirect({ to: '/estimation/new/basics/project' });
  },
});
